import './Orb.css';

// CSS-only orb: a masked conic gradient spinning on the compositor (no canvas, no WebGL)
export default function Orb({ forceHoverState = false }) {
  return (
    <div className="orb-container" aria-hidden="true">
      <div className={forceHoverState ? 'ai-orb ai-orb--active' : 'ai-orb'} />
    </div>
  );
}
